export default __webpack_public_path__ + "static/media/liza_kraff.6cb22407.png";